import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';

import { useCostContext } from './CostProvider';
import { COST_TYPE } from '../helpers/consts';
import { customizedType } from '../helpers/localeHelper';

const PickerModalError = ({ error, onTryAgain, type = '' }) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  const { terminologies } = useCostContext();
  // no permission
  if (error && error.status === 403) {
    return (
      <EmptyState
        illustrationType={EmptyState.ILLUSTRATION_TYPES.NO_PERMISSION}
        description={T.translate('NO_PERMISSION', {
          type: customizedType(T, type, terminologies),
        })}
      />
    );
  }

  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.CRANE_CONSTRUCTION_GREY}
      description={T.translate('ERROR_LOADING', {
        type: customizedType(T, type, terminologies),
      })}
    >
      <LinkButton onClick={onTryAgain}>{T.translate('TRY_AGAIN')}</LinkButton>
    </EmptyState>
  );
};

PickerModalError.propTypes = {
  /**
   * error of fetching list.
   */
  error: PropTypes.object,
  /**
   * Callback to fetch data again.
   */
  onTryAgain: PropTypes.func,
  /**
   * The cost type, should be one of 'pco', 'oco', 'sco', 'rfq', 'rco'
   */
  type: PropTypes.oneOf(COST_TYPE).isRequired,
};

export default PickerModalError;
